<section
    class="tw-w-full tw-max-w-[1200px] tw-mx-auto tw-px-[15px] tw-my-[50px] tw-relative"
>
    <h2 class="!tw-text-[40px] tw-text-[#0F268F] !tw-mb-3">
        {{ "GRANTS.ALL_GRANTS" | translate }}
    </h2>
    <p class="tw-font-semibold !tw-mb-[50px]">
        {{ "GRANTS.GRANT_DESC" | translate }}
    </p>

    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-relative">
        <div
            class="tw-btn-common tw-flex sm:tw-hidden tw-w-full !tw-rounded-[34px]"
        >
            <input
                type="text"
                [(ngModel)]="searchText"
                (input)="onSearch()"
                placeholder="{{ 'GRANTS.SEARCH' | translate }}"
                class="tw-input-search tw-w-full"
            />
            <img
                src="../../../../../assets/images/New-Miti/search.png"
                alt="search"
            />
        </div>

        <div class="tw-flex tw-w-full tw-gap-3">
            <button
                (click)="toggleFilter()"
                class="tw-btn-common tw-flex tw-w-[200px]"
            >
                <div>{{ "GRANTS.FILTER" | translate }}</div>
                <img
                    src="../../../../../assets/images/New-Miti/filter.png"
                    alt="filter"
                />
            </button>

            <!-- Desktop Search Button (Hidden on Mobile) -->
            <div class="tw-btn-common tw-hidden md:tw-flex tw-flex-grow">
                <input
                    type="text"
                    [(ngModel)]="searchText"
                    (input)="onSearch()"
                    placeholder="{{ 'GRANTS.SEARCH' | translate }}"
                    class="tw-input-search tw-w-full"
                />
                <img
                    src="../../../../../assets/images/New-Miti/search.png"
                    alt="search"
                />
            </div>

            <button
                (click)="toggleSort()"
                class="tw-btn-common tw-flex tw-w-[200px]"
            >
                <div>{{ "GRANTS.SORT_BY" | translate }}</div>
                <img
                    src="../../../../../assets/images/New-Miti/sort.png"
                    alt="sort"
                />
            </button>
        </div>
    </div>
    <div
        *ngIf="isFormFilter"
        class="tw-text-left tw-flex tw-flex-wrap tw-gap-5 tw-items-center tw-my-[20px]"
    >
        <div class="tw-text-base tw-font-semibold tw-text-caption-gray">
            <span class="tw-text-[#7B7575]">{{ filteredMitiData.length }}</span>
            <span>
                {{
                    filteredMitiData.length == 1
                        ? ("NEW_APPLICATION.RESULT_FOUND" | translate)
                        : ("NEW_APPLICATION.RESULTS_FOUND" | translate)
                }}
            </span>
        </div>

        <span
            class="tw-px-[20px] tw-py-[3px] tw-rounded-full tw-bg-gray-300 tw-border tw-border-gray-500 tw-text-gray-500 tw-text-[12px]"
        >
            {{
                getFilterLabel(
                    formResults?.operationDuration,
                    selectedLanguage,
                    "bo"
                )
            }}
        </span>
        <span
            class="tw-px-[20px] tw-py-[3px] tw-rounded-full tw-bg-gray-300 tw-border tw-border-gray-500 tw-text-gray-500 tw-text-[12px]"
        >
            {{
                getFilterLabel(
                    formResults?.fundingAmount,
                    selectedLanguage,
                    "fa"
                )
            }}
        </span>
        <span
            *ngFor="let ind of formResults?.industry"
            class="tw-px-[20px] tw-py-[3px] tw-rounded-full tw-bg-gray-300 tw-border tw-border-gray-500 tw-text-gray-500 tw-text-[12px]"
        >
            {{ getFilterLabel(ind, selectedLanguage, "ind") }}
        </span>
        <button
            (click)="clearAllFilters()"
            class="tw-px-[20px] tw-py-[3px] tw-rounded-full tw-bg-red-300 tw-border tw-border-red-500 tw-text-red-500 tw-cursor-pointer"
        >
            {{ "GRANTS.CLEAR_ALL" | translate }}
        </button>
    </div>

    <!-- Sorting Menu (Desktop & Mobile) -->
    <div
        *ngIf="sort"
        class="tw-absolute tw-right-0 tw-mt-2 tw-mr-4 tw-z-10"
        #sortMenu
    >
        <div
            class="tw-flex tw-flex-col tw-w-[200px] tw-p-5 tw-box-border tw-font-semibold tw-text-[14px] tw-text-[#414141] tw-bg-white tw-border tw-border-gray-300 tw-rounded-[8px] tw-drop-shadow-[0px_4px_4px_rgba(0,0,0,0.25)]"
        >
            <div
                class="tw-flex md:tw-hidden tw-items-center tw-pb-2 md:tw-mb-2 tw-mb-0 tw-border-b tw-border-[#000000]"
            >
                <mat-icon (click)="onClose()">close</mat-icon>
                <span class="tw-ml-4">
                    {{ "GRANTS.SORT_BY" | translate }}
                </span>
            </div>
            <!-- Desktop: Clickable Options -->
            <div
                *ngFor="let option of sortOptions; let i = index"
                class="tw-cursor-pointer tw-hidden sm:tw-flex"
                [ngClass]="{
                    'tw-text-[#0F268F]': activeSort === option.value,
                    'tw-mt-0': i === 0,
                    'tw-mt-4': i !== 0
                }"
                (click)="sortMitiData(option.value)"
            >
                {{ option.label | translate }}
            </div>

            <!-- Mobile: Radio Buttons -->
            <div
                *ngFor="let option of sortOptions; let i = index"
                class="tw-flex tw-items-center tw-mt-4 sm:tw-hidden"
            >
                <input
                    type="radio"
                    id="sort-{{ option.value }}"
                    name="sort"
                    [value]="option.value"
                    [checked]="activeSort === option.value"
                    (change)="sortMitiData(option.value)"
                    class="tw-mr-2"
                />
                <label for="sort-{{ option.value }}">
                    {{ option.label | translate }}
                </label>
            </div>
        </div>
    </div>
    <div
        *ngIf="filteredMitiData.length === 0"
        class="tw-text-base tw-font-semibold tw-text-center tw-text-[#003A70] tw-mt-6"
    >
        {{
            (searchText
                ? "NEW_APPLICATION.NO_SEARCH_RESULT"
                : "NEW_APPLICATION.NO_GRANTS_RESULT"
            ) | translate
        }}
    </div>

    <div class="tw-flex">
        <div
            class="md:tw-static tw-absolute tw-z-10"
            [ngClass]="{
                'tw-mt-11 sm:tw-mt-0':
                    appliedFilters.length > 0 && totalMatchedCount == 0
            }"
            #appliedFiltersDiv
        >
            <!-- Applied Filters Section -->
            <div
                *ngIf="appliedFilters.length > 0 && showAppliedFilter"
                class="tw-px-3 tw-mt-2 tw-pb-2 tw-w-[285px] tw-mr-5 tw-box-border tw-bg-white tw-rounded-[8px] tw-font-semibold tw-text-[14px] tw-text-[#414141] tw-drop-shadow-[0px_4px_4px_rgba(0,0,0,0.25)]"
            >
                <div class="tw-flex tw-items-center tw-justify-between tw-pt-3">
                    <div>
                        {{ "GRANTS.APPLIED_FILTERS" | translate }}
                    </div>
                    <button
                        (click)="clearAllFilters()"
                        class="tw-text-[#0F268F] tw-text-[12px] tw-font-medium"
                    >
                        {{ "GRANTS.CLEAR_ALL" | translate }}
                    </button>
                </div>
                <div class="">
                    <div
                        *ngFor="
                            let filter of appliedFilters.slice(
                                0,
                                showAll ? appliedFilters.length : 3
                            );
                            let j = index
                        "
                        class="tw-flex tw-items-center tw-m-w-[200px] tw-my-2 tw-justify-between tw-border tw-rounded-[4px] tw-px-2 tw-py-1 tw-text-[12px]"
                    >
                        {{ filter.value }}
                        <mat-icon
                            class="tw-ml-1 tw-cursor-pointer"
                            (click)="removeFilter(j)"
                        >
                            close
                        </mat-icon>
                    </div>
                    <button
                        *ngIf="appliedFilters.length > 3"
                        class="tw-mt-2 tw-cursor-pointer tw-text-[14px] tw-text-[#0f268f]"
                        (click)="toggleShowAll($event)"
                    >
                        {{
                            showAll
                                ? ("GRANTS.SHOW_LESS" | translate)
                                : ("GRANTS.SHOW_MORE" | translate)
                        }}
                    </button>
                </div>
            </div>
            <div
                *ngIf="showMainFilter"
                class="tw-bg-white tw-z-10 tw-pb-5 tw-rounded-[8px] tw-mt-2"
                #filterMenu
            >
                <div
                    *ngFor="let ftr of filters; let i = index"
                    class="tw-px-4 tw-mt-2 tw-pb-2 tw-w-[285px] tw-mr-5 tw-box-border tw-bg-white tw-rounded-[8px] tw-font-semibold tw-text-[14px] tw-text-[#414141] tw-drop-shadow-[0px_4px_4px_rgba(0,0,0,0.25)]"
                >
                    <!-- Main Filter Title -->
                    <div
                        (click)="toggleSubFilter(i)"
                        class="tw-flex tw-items-center tw-justify-between tw-h-[52px] tw-cursor-pointer"
                    >
                        <div>{{ ftr.name | translate }}</div>
                        <mat-icon>
                            {{
                                showSubFilters[i]
                                    ? "keyboard_arrow_up"
                                    : "keyboard_arrow_down"
                            }}
                        </mat-icon>
                    </div>

                    <!-- Sub-Filters (Dropdown) -->
                    <div *ngIf="showSubFilters[i]">
                        <div
                            *ngFor="let sub of ftr.subFilters"
                            class="tw-flex tw-items-center tw-mb-4"
                        >
                            <input
                                type="checkbox"
                                [checked]="
                                    selectedFilters[ftr.name]?.includes(
                                        sub.filterBy
                                    ) ||
                                    (sub.filterBy === 'All' &&
                                        selectedFilters[ftr.name]?.length ===
                                            ftr.subFilters.length - 1)
                                "
                                (change)="onFilter(ftr.name, sub)"
                                class="tw-mr-2"
                            />
                            <span *ngIf="selectedLanguage === 'en'">{{
                                sub.label
                            }}</span>
                            <span *ngIf="selectedLanguage === 'bm'">{{
                                sub.labelBM
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div
                class="tw-text-2xl tw-font-semibold tw-pt-9 tw-pb-3 tw-border-opacity-10"
                *ngIf="
                    searchText.length === 0 &&
                    isFiltersApplied &&
                    totalMatchedCount > 0
                "
            >
                {{ totalMatchedCount }}
                <ng-container
                    *ngIf="totalMatchedCount == 1; else multipleProducts"
                >
                    {{ "NEW_APPLICATION.RESULT_FOUND" | translate }}
                </ng-container>
                <ng-template #multipleProducts>
                    {{ "NEW_APPLICATION.RESULTS_FOUND" | translate }}
                </ng-template>
                <div class="tw-text-base tw-font-semibold tw-text-caption-gray">
                    {{ "NEW_APPLICATION.BASED_ON_FILTER" | translate }}
                </div>
            </div>

            <div
                class="tw-text-2xl tw-font-semibold tw-pt-9 tw-pb-3 tw-border-opacity-10"
                *ngIf="searchText.length > 0 && totalMatchedCount > 0"
            >
                {{ totalMatchedCount }}
                <ng-container
                    *ngIf="totalMatchedCount == 1; else multipleProducts"
                >
                    {{ "NEW_APPLICATION.RESULT_FOUND" | translate }}
                </ng-container>
                <ng-template #multipleProducts>
                    {{ "NEW_APPLICATION.RESULTS_FOUND" | translate }}
                </ng-template>
                <div class="tw-text-base tw-font-semibold tw-text-caption-gray">
                    {{ "NEW_APPLICATION.BASED_ON_SEARCH" | translate }}
                </div>
            </div>
            <div
                [ngClass]="
                    showMainFilter
                        ? 'sm:tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-3  xl:tw-grid-cols-3'
                        : 'sm:tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4'
                "
                class="tw-grid tw-grid-cols-1 tw-mt-5 tw-gap-[25px]"
            >
                <app-grant-card
                    *ngFor="let item of filteredMitiData"
                    [mitiProduct]="item"
                    [selectedLanguage]="selectedLanguage"
                ></app-grant-card>
            </div>
        </div>
    </div>
</section>
<div
    *ngIf="imgs?.length > 0"
    class="tw-min-h-[160px] tw-flex tw-items-center tw-bg-[#EFEFEF] tw-py-[50px]"
>
    <div
        class="tw-max-w-[1200px] tw-mx-auto tw-overflow-x-auto tw-w-full tw-px-[20px] tw-flex tw-justify-start md:tw-justify-center tw-gap-[50px]"
    >
        <img
            *ngFor="let img of imgs"
            [src]="img"
            alt="Miti-Logo"
            class="tw-max-w-[200px] footer-img"
        />
    </div>
</div>
